// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1SEV-","notes":"Notes_notes__2dv9p","note":"Notes_note___HCfC","markdown":"Notes_markdown__2KuEK"};